(function(){
    'use strict';

    angular.module('elogbooks.user.my-details', []);
})();